<div class="page-container case-management-container container">
  <app-breadcrumb [crumbConfig]="crumbConfig"></app-breadcrumb>

  <app-rb-grid
    [gridConfig]="gridConfig"
    [getSetup]="getGridSetup"
    [getData]="getGridData"
    (deleteItem)="deleteCase($event)"
  >
    @if (rights.includes('CreateCMCaseAdHoc')) {
      <button
        mat-button
        color="primary"
        class="grid-button header-button"
        (click)="createAdHocCase()"
      >
        <mat-icon>add_circle_outline</mat-icon>Create Case
      </button>
    }
  </app-rb-grid>
</div>
